// extracted by mini-css-extract-plugin
export default {"wrapper":"GetGuide_wrapper__KRkIA","mainContainer":"GetGuide_mainContainer__FBrA7","error":"GetGuide_error__wNSUo"};